import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CustomerModel } from '../../../../customer/customer.model';

/**
 * Collect Payment's reminder of whom the payment is for, shown under the title of the
 * payment-method and invoice steps — Step 1's selection is otherwise out of sight once the
 * operator moves on. Renders nothing without a customer (a one-time payment clears it).
 */
@Component({
  selector: 'app-selected-customer',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './selected-customer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedCustomerComponent {
  @Input() customer: CustomerModel | null | undefined;
  /** False where the customer comes from the transaction (adjust, refund, complete auth). */
  @Input() canChange = true;
  // Not `change`: a native `change` event bubbling to the host would fire it too.
  @Output() changeCustomer = new EventEmitter<void>();

  /** `companyName`, falling back to `displayName` — the rule `customerAccountLabel` uses. */
  get name(): string {
    return (this.customer?.companyName || this.customer?.displayName || '').trim();
  }

  get accountNumber(): string {
    return (this.customer?.companyAccountNumber ?? '').trim();
  }
}
